// extracted by mini-css-extract-plugin
export var base = "_45-0";
export var updateBanner = "_45-1";